import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { ExitButton } from '../styled-components/components';
import { toggleModal, clearActions, copyPreset, destinationPresetChange } from '../actions';
import { StyledOption, OptionText, OptionSelect } from '../styled-components/option-styling';

const StyledModal = styled.div`
    position:absolute;
    top:0;
    left:0;
    text-align:center;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,.9);
`

const ModalContainer = styled.div`
    position:absolute;
    text-align:center;
    width:480px;
    border:1px solid #808080;
    padding:0;
    box-sizing:border-box;
    background:rgba(0,0,0,.9);
    left:50%;
    top:50%;
    margin-left:-280px;
    margin-top:-92px;
`

const ModalHeading = styled.h1`
    font-size:24px;
    padding:30px;

`
const ModalButton = styled.button`
    width: ${props => props.width};
    background:none;
    border: none;
    border-top: 1px solid #808080;
    color:white;
    cursor:pointer;
    padding:20px 0;
    float:left;
    text-align:center;
    font-size:20px;
    transition:.2s all;
    &:last-of-type{
        border-left:1px solid #808080;
    }
    &:hover{
        background:#111;
    }
`

const ModalExitButton = styled(ExitButton)
    `
    top:0px;
    right:0px;
`

const ModalInput = styled.input

    `
    width: 100%;

`


const Modal = ({ modal, preset, dispatch }) => {
    if (modal.screen !== undefined && modal.screen.includes("Modal")) {
        var options = []
        for (var x = 1; x <= 28; x++) {
            options.push(<option key={x}> {x} </option>)
        }
        return (<StyledModal>
            <ModalContainer><ModalHeading>{modal.modal}</ModalHeading>

                <ModalExitButton onClick={() => dispatch(toggleModal({ screen: "default" }))} />
                {(modal.screen === 'newDocModal' || modal.screen === 'downloadModal') &&
                    <>
                        <ModalButton width="50%" onClick={() => {
                            dispatch(toggleModal({ screen: "default" }));
                            for (var actionNum in modal.success.action) {
                                dispatch(modal.success.action[actionNum])
                            }
                            return null
                        }
                        }>Yes
                        </ModalButton>
                        <ModalButton width="50%" onClick={() => dispatch(toggleModal({ screen: "default" }))}>No</ModalButton>
                    </>
                }
                {modal.screen === 'copyPresetModal' &&
                    <>
                        <StyledOption onChange={(e) => {
                            modal.option = e.target.value
                        }}>
                            <OptionText>Copy to Preset Number (preset will be replaced):</OptionText>
                            <OptionSelect >
                                {options}
                            </OptionSelect>
                        </StyledOption>

                        <ModalButton width="100%" onClick={() => {

                            dispatch(toggleModal({ screen: "default" }));
                            dispatch(copyPreset(preset, modal.option));
                        }}>Ok</ModalButton>

                    </>}
            </ModalContainer>
        </StyledModal>)
    } else {
        return (null)
    }
}

function mapStateToProps(state) {
    return {
        modal: state.screen,
        preset: state.preset
    }
}
export default connect(mapStateToProps)(Modal)